import axios from "./request"

export default {
  async send(data) {
    return (await axios.post('/notifications/send', data)).data
  }
}
